export const domaines = [
    { code: "001", text: "Activités politiques" },
    { code: "002", text: "Clubs, cercles de réflexion" },
    { code: "003", text: "Défense de droits fondamentaux, activités civiques" },
    { code: "004", text: "Justice" },
    { code: "005", text: "Information communication" },
    { code: "006", text: "Culture, pratiques d'activités artistiques, Culturelles " },
    { code: "007", text: "Clubs de loisirs, relations" },
    { code: "009", text: "Action socio-culturelle" },
    { code: "010", text: "Préservation du patrimoine" },
    { code: "011", text: "Sports" },
    { code: "013", text: "Chasse pêche" },
    { code: "014", text: "Amicales, groupements affinitaires, d'entraide" },
    { code: "015", text: "Éducation formation" },
    { code: "016", text: "Recherche" },
    { code: "017", text: "Santé" },
    { code: "018", text: "Services et établissements médico-sociaux" },
    { code: "019", text: "Interventions sociales" },
    { code: "020", text: "Associations caritatives, humanitaires, aide au développement" },
    { code: "021", text: "Services familiaux, services aux personnes âgées" },
    { code: "022", text: "Conduite d'activités économiques" },
    { code: "023", text: "Représentation, promotion et défense d'intérêts économiques" },
    { code: "024", text: "Environnement" },
    { code: "030", text: "Aide à l'emploi, développement local, solidarité économique" },
    { code: "032", text: "Logement" },
    { code: "034", text: "Tourisme" },
    { code: "036", text: "Sécurité, protection civile" },
    { code: "038", text: "Armée (dont préparation militaire, médailles) ..." },
    { code: "040", text: "Activités religieuses, spirituelles ou philosophiques" },
    { code: "050", text: "Domaines divers" },
];

const themes = [
    { code: "001005", text: "associations à caractère politique général" },
    { code: "001010", text: "soutien, financement de partis et de campagnes électorales" },
    { code: "001015", text: "action politique locale" },
    { code: "001020", text: "action politique globale" },
    { code: "001025", text: "activités citoyennes européennes " },
    { code: "002005", text: "associations philanthropiques" },
    { code: "002010", text: "amicales laïques" },
    { code: "002015", text: "clubs de réflexion" },
    { code: "002020", text: "organisation de conférences" },
    { code: "003010", text: "défense de la paix" },
    { code: "003012", text: "défense des droits des enfants" },
    { code: "003015", text: "défense des libertés publiques et des droits de l'Homme" },
    { code: "003020", text: "défense des droits des femmes, condition féminine" },
    { code: "003025", text: "défense des droits des personnes homosexuelles" },
    { code: "003030", text: "défense des droits des personnes en situation de handicap" },
    { code: "003035", text: "défense des droits des minorités" },
    { code: "003040", text: "lutte contre les discriminations" },
    { code: "003045", text: "défense des droits des personnes rapatriées" },
    { code: "003050", text: "défense des droits des personnes étrangères ou immigrées" },
    { code: "004010", text: "médiation, prévention" },
    { code: "004020", text: "contrôle judiciaire, associations de personnels de justice" },
    { code: "004025", text: "accès aux droits dans les tribunaux, assistance juridique" },
    { code: "004030", text: "défense des droits des victimes" },
    { code: "004035", text: "maison du droit, accès au droit" },
    { code: "005005", text: "presse, édition" },
    { code: "005010", text: "radios privées" },
    { code: "005015", text: "audiovisuel" },
    { code: "005020", text: "réseaux internet" },
    { code: "005025", text: "autres supports de communication" },
    { code: "005030", text: "auditeurs, consommateurs outils d'information et communicati" },
    { code: "005035", text: "professionnels de l'information et de communication" },
    { code: "006005", text: "bibliothèques, ludothèques, discothèques, vidéothèques" },
    { code: "006010", text: "expression écrite, littérature, poésie" },
    { code: "006020", text: "arts graphiques, bande dessinée,peinture,sculpture, architect" },
    { code: "006025", text: "photographie, cinéma (dont ciné-clubs)" },
    { code: "006030", text: "chant choral, musique" },
    { code: "006040", text: "danse" },
    { code: "006045", text: "folklore" },
    { code: "006070", text: "théâtre, marionettes, cirque, spectacles de variété" },
    { code: "006090", text: "artisanat, travaux manuels, bricolage, expositions" },
    { code: "006100", text: "promotion de l'art et des artistes" },
    { code: "006105", text: "Loisirs scientifiques et techniques" },
    { code: "006110", text: "langues, dialectes, patois" },
    { code: "006115", text: "arts de la rue" },
    { code: "007002", text: "aéroclubs" },
    { code: "007003", text: "modélisme" },
    { code: "007005", text: "bridge, jeux de cartes, échecs, dames, jeux de société..." },
    { code: "007010", text: "billard, quilles" },
    { code: "007025", text: "collectionneurs ( sauf véhicule ), philatélie, numismatique" },
    { code: "007030", text: "collectionneurs, club amateurs de voitures anciennes" },
    { code: "007035", text: "cercles privés, fan-clubs" },
    { code: "007040", text: "activités festives ( soirées ..." },
    { code: "007045", text: "élevage canin, clubs de chiens de défense" },
    { code: "007050", text: "animaux familiers, colombophilie, aquariophilie" },
    { code: "007060", text: "gastronomie, oenologie, confréries, gourmets" },
    { code: "007070", text: "jardinage, jardins ouvriers, floralies" },
    { code: "007075", text: "échanges locaux, réseaux d'échanges" },
    { code: "007080", text: "centres de loisirs, clubs de loisirs multiples" },
    { code: "007085", text: "relaxation, sophrologie" },
    { code: "007095", text: "radioamateurs" },
    { code: "009005", text: "maisons de jeunes, foyers, clubs de jeunes" },
    { code: "009007", text: "maisons de la culture, office municipal, centre culturel" },
    { code: "009010", text: "loisirs pour personnes en situation de handicap" },
    { code: "009015", text: "associations socio-éducatives, scoutisme" },
    { code: "009020", text: "centres aérés, colonies de vacances" },
    { code: "009025", text: "mouvements éducatifs de jeunesse et d'éducation populaire" },
    { code: "009030", text: "comités des fêtes" },
    { code: "009035", text: "foyers ruraux" },
    { code: "009040", text: "clubs du troisième âge" },
    { code: "009045", text: "majorettes, twirlings, carnavals, défilés" },
    { code: "009050", text: "jumelages, échanges culturels, échanges linguistiques" },
    { code: "010005", text: "collections d'objets, de documents, bibliothèques spécialisé" },
    { code: "010010", text: "musées, collections historiques" },
    { code: "010015", text: "associations, sociétés savantes pour des études historiques" },
    { code: "010017", text: "sociétés, clubs de généalogie" },
    { code: "010020", text: "entretien de monuments et sites historiques, souvenir milita" },
    { code: "010022", text: "comités de défense du patrimoine" },
    { code: "010030", text: "construction de monuments (sauf lieux de culte)" },
    { code: "011004", text: "arbitrage" },
    { code: "011005", text: "associations multi-sports locales" },
    { code: "011010", text: "associations multi-sports scolaires ou universitaires" },
    { code: "011015", text: "associations multi-sports d'entreprise" },
    { code: "011018", text: "handisport" },
    { code: "011020", text: "Athlétisme (triathlon, pentathlon, footing, jogging)" },
    { code: "011025", text: "Aviron, canoë kayak (aviron, rafting, canoë kayak, joutes)" },
    { code: "011030", text: "Badminton (badminton. squash. pelote basque)" },
    { code: "011035", text: "Boules (pétanque, boules)" },
    { code: "011040", text: "Bowling" },
    { code: "011045", text: "Danse sportive (danse sportive, hip hop, claquettes)" },
    { code: "011050", text: "Equitation (équitation, hippisme, course camarguaise, landai" },
    { code: "011055", text: "Escalade, montaqne (escalade, spéléologie, via ferrata, can" },
    { code: "011060", text: "Escrime" },
    { code: "011065", text: "Basket-ball" },
    { code: "011070", text: "Handball" },
    { code: "011075", text: "Football (football, futsal)" },
    { code: "011080", text: "Rugby (rugby à 13, à 15)" },
    { code: "011085", text: "Volley ball (volley, beach volley)" },
    { code: "011090", text: "Autres sports collectifs (base ball, hockey, football améric" },
    { code: "011092", text: "hockey sur glace, sports de glace" },
    { code: "011095", text: "nautisme, glisse sur eau (ski nautique, surf, char à voile" },
    { code: "011100", text: "Golf" },
    { code: "011105", text: "Gymnastique (gymnastique d'entretien, éducation physique,yo" },
    { code: "011110", text: "Haltérophilie" },
    { code: "011115", text: "Marche sportive (randonnée pédestre, raid, trekking, course" },
    { code: "011120", text: "Musculation (culturisme, musculation)" },
    { code: "011125", text: "Natation - Baignade (natation, plongée)" },
    { code: "011130", text: "Roller, skate" },
    { code: "011135", text: "Sports aériens (avion, planeur, ULM, parachutisme)" },
    { code: "011140", text: "Judo" },
    { code: "011145", text: "Sports de combat (boxe, kick box, boxe thai, lutte)" },
    { code: "011150", text: "Autres arts martiaux (karaté, aikido, taekwondo)" },
    { code: "011155", text: "Sports de neige (ski alpin, ski de fond, snowboard) , montag" },
    { code: "011160", text: "Sports mécaniques (sport automobile, moto, trial)" },
    { code: "011165", text: "Tennis (tennis, longue paume)" },
    { code: "011170", text: "Tennis de table (tennis de table, ping-pong)" },
    { code: "011175", text: "Tir (tir à l'arc, tir à balle, ball trap), javelot" },
    { code: "011180", text: "Cyclisme (cyclisme, vélo, VTT, y c course d'orientation à" },
    { code: "011185", text: "Voile (voile, dériveur, planche à voile)" },
    { code: "011190", text: "gestion d'équipements, championnats, clubs de supporters" },
    { code: "011192", text: "promotion du sport, médailles, mérite sportif" },
    { code: "011400", text: "activités de plein air (dont saut à l'élastique)" },
    { code: "013005", text: "chasse" },
    { code: "013010", text: "pêche" },
    { code: "014025", text: "organisation de professions (hors caractère syndical)" },
    { code: "014030", text: "association du personnel d'une entreprise (non syndical)" },
    { code: "014035", text: "groupements d'entraide et de solidarité" },
    { code: "014040", text: "amicale de personnes originaires d'un même pays (hors défens" },
    { code: "014045", text: "amicale de personnes originaires d'une même région" },
    { code: "014050", text: "associations féminines pour l'entraide et la solidarité" },
    { code: "014060", text: "entraide et solidarité des personnes homosexuelles" },
    { code: "014070", text: "entraide et solidarité des personnes en situation de handica" },
    { code: "014080", text: "associations de classe d'âge" },
    { code: "015005", text: "parents d'élèves" },
    { code: "015010", text: "organisation de professions enseignantes, amicales de person" },
    { code: "015025", text: "associations périscolaires, coopération, aide à l'enseignem" },
    { code: "015030", text: "oeuvres sociales en faveur des élèves, pupilles de la nation" },
    { code: "015035", text: "organisme de gestion d'établissement d'enseignement général" },
    { code: "015040", text: "organisme de gestion d'établissement d'enseignement supérieu" },
    { code: "015045", text: "établissement de formation professionnelle, formation continue" },
    { code: "015050", text: "centre d'enseignement et de formation" },
    { code: "015065", text: "associations d'étudiants, d'élèves" },
    { code: "015070", text: "amicales, associations d'anciens étudiants, d'anciens élèves" },
    { code: "015075", text: "amicales, personnel d'établissements scolaires ou universita" },
    { code: "015085", text: "organisation, financement de voyages d'études, d'échanges, p" },
    { code: "015087", text: "études et formations linguistiques" },
    { code: "015090", text: "promotion de titres, de diplômes" },
    { code: "015100", text: "apprentissage" },
    { code: "015105", text: "maisons familiales rurales" },
    { code: "016005", text: "recherche sur l'éducation et la formation" },
    { code: "016010", text: "recherche sur la culture" },
    { code: "016015", text: "recherche sur la vie sociale et politique" },
    { code: "016025", text: "recherche sur l'environnement et le climat" },
    { code: "016030", text: "recherches scientifiques, sciences physiques, sciences humai" },
    { code: "016050", text: "autres associations de recherche" },
    { code: "016080", text: "diffusion de savoirs, sociétés savantes ou académiques" },
    { code: "017005", text: "cliniques, centres médicaux, hôpitaux, sanatoriums" },
    { code: "017015", text: "hôpitaux psychiatriques, soins ambulatoires en santé mentale" },
    { code: "017020", text: "dispensaires, soins infirmiers, services paramédicaux, de ga" },
    { code: "017025", text: "services médicaux d'urgence" },
    { code: "017045", text: "centres de réadaptation" },
    { code: "017055", text: "accompagnement, aide aux malades" },
    { code: "017065", text: "don de sang, d'organes" },
    { code: "017075", text: "gestion de matériel médical" },
    { code: "017085", text: "hygiène, diététique" },
    { code: "017095", text: "accueil, information pour contraception et avortement" },
    { code: "017105", text: "médecine du travail" },
    { code: "017115", text: "prévention et dépistage du sida" },
    { code: "017120", text: "éducation sanitaire, prévention générale" },
    { code: "017125", text: "prévention et dépistage de maladies (autres que le sida)" },
    { code: "017130", text: "associations de personnes malades, ou anciens malades" },
    { code: "017135", text: "homéopathie, médecines douces" },
    { code: "017145", text: "organisation de professions médicales ou paramédicales" },
    { code: "017155", text: "organisation de congrès médicaux" },
    { code: "017200", text: "recherche médicale" },
    { code: "017210", text: "financement de la recherche médicale" },
    { code: "017300", text: "médecine animale, vétérinaire" },
    { code: "018005", text: "accueil et protection de la petite enfance" },
    { code: "018010", text: "établissements et services pour adolescents en difficulté" },
    { code: "018015", text: "établissements, services pour personnes handicapées (y c CAT" },
    { code: "018025", text: "établissements et services pour adultes en difficulté, CHRS" },
    { code: "018030", text: "prévention et lutte contre l'alcoolisme,, le tabac, la toxi" },
    { code: "018040", text: "aide aux accidentés du travail" },
    { code: "018045", text: "aide aux victimes de maladies professionnelles" },
    { code: "018050", text: "aide sociale aux personnes en situation de handicap" },
    { code: "019004", text: "aide et conseils aux familles" },
    { code: "019005", text: "associations familiales, services sociaux pour les familles" },
    { code: "019010", text: "centres sociaux, foyers de jeunes travailleurs" },
    { code: "019012", text: "lutte contre le surendettement" },
    { code: "019014", text: "lutte contre l'illettrisme" },
    { code: "019016", text: "aide à l'insertion des jeunes" },
    { code: "019020", text: "groupements de chômeurs, aide aux chômeurs" },
    { code: "019025", text: "aide aux réfugiés et aux immigrés (hors droits fondamentaux)" },
    { code: "019030", text: "aide aux victimes de calamités, de catastrophes naturelles" },
    { code: "019032", text: "aide aux victimes de violences conjugales" },
    { code: "019035", text: "aide aux victimes de violences faites aux enfants" },
    { code: "019040", text: "aide aux personnes en danger, solitude, désespoir, soutien p" },
    { code: "019042", text: "lutte contre la violence routière" },
    { code: "019045", text: "lutte contre diverses formes de violence" },
    { code: "019047", text: "foyers socio-éducatifs" },
    { code: "019050", text: "réinsertion des délinquants" },
    { code: "019055", text: "soutien, reclassement des détenus" },
    { code: "020005", text: "secours financiers et autres services aux personnes en diffi" },
    { code: "020010", text: "secours en nature, distribution de nourriture et de vêtement" },
    { code: "020015", text: "associations caritatives à buts multiples" },
    { code: "020020", text: "associations caritatives intervenant au plan international" },
    { code: "020025", text: "développement du bénévolat" },
    { code: "021005", text: "crèches, garderies, haltes garderies" },
    { code: "021010", text: "aide à domicile" },
    { code: "021015", text: "services aux personnes âgées (téléalarme.." },
    { code: "021020", text: "foyers ,maisons de retraite. maisons de retraite médicalisées" },
    { code: "022510", text: "cantines, restaurants d'entreprises" },
    { code: "022515", text: "centres de gestion, centres juridiques, audits" },
    { code: "022520", text: "gestion financière, gestion immobilière" },
    { code: "022525", text: "études techniques" },
    { code: "022530", text: "groupement d'achats, groupement d'entreprises" },
    { code: "022535", text: "amicales de commerçants, organisation de foires" },
    { code: "022540", text: "chambres de commerce, chambres économiques" },
    { code: "022542", text: "association à but commercial, développement économique" },
    { code: "022543", text: "transports" },
    { code: "022545", text: "caisses de retraite, de prévoyance, de pensions" },
    { code: "023001", text: "usagers de services publics" },
    { code: "023002", text: "mouvements de consommateurs" },
    { code: "023003", text: "défense des contribuables" },
    { code: "023004", text: "actionnaires, épargnants" },
    { code: "023005", text: "groupements de salariés à caractère syndical" },
    { code: "023007", text: "groupements professionnels" },
    { code: "023010", text: "défense d'intérêts des retraités ou des personnes âgées" },
    { code: "023020", text: "exploitants agricoles, élevage, horticulture, aviculture .." },
    { code: "023022", text: "associations d'intérêts maritimes, marins" },
    { code: "023025", text: "artisans commerçants" },
    { code: "023030", text: "unions patronales" },
    { code: "023035", text: "professions libérales" },
    { code: "023040", text: "représentation d'intérêts économiques sectoriels" },
    { code: "023045", text: "représentation d'intérêts régionaux et locaux" },
    { code: "024005", text: "pollutions, assainissement" },
    { code: "024010", text: "ressources naturelles" },
    { code: "024015", text: "espaces naturels" },
    { code: "024020", text: "protection de sites naturels" },
    { code: "024025", text: "préservation de la faune sauvage" },
    { code: "024026", text: "protection des animaux" },
    { code: "024030", text: "préservation de la flore sauvage" },
    { code: "024035", text: "comités de défense, de sauvegarde" },
    { code: "024040", text: "mouvements écologiques" },
    { code: "024045", text: "défense et amélioration du cadre de vie" },
    { code: "024050", text: "action sensibilisation environnement , développement durab" },
    { code: "030005", text: "défense d'emploi" },
    { code: "030010", text: "entreprises d'insertion, régies de quartier" },
    { code: "030012", text: "comités de défense et d'animation de quartier" },
    { code: "030015", text: "groupement d'employeurs" },
    { code: "030020", text: "aide à la création d'activités économiques individuelles" },
    { code: "030050", text: "promotion d'initiatives de développement durable" },
    { code: "032510", text: "aide au logement" },
    { code: "032520", text: "comités de logement, de locataires, de propriétaires" },
    { code: "032525", text: "réhabilitation et construction de logements" },
    { code: "034210", text: "auberges de jeunesse, organisation de voyages" },
    { code: "034220", text: "maisons et villages de vacances" },
    { code: "034230", text: "gites ruraux, camping, caravaning, naturisme" },
    { code: "034240", text: "syndicats d'initiative, offices de tourisme, salons du touri" },
    { code: "036510", text: "amicale de sapeurs pompiers" },
    { code: "036520", text: "sauvetage, secourisme, protection civile" },
    { code: "036530", text: "prévention, formation, cours de secourisme" },
    { code: "036535", text: "sécurité routière" },
    { code: "036540", text: "sauvetage en mer" },
    { code: "036545", text: "sécurité et sauvetage en montagne" },
    { code: "038105", text: "anciens combattants" },
    { code: "038110", text: "associations de militaires, de conscrits, amicales" },

];

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function themesDuDomaine(doms) {
    const codes = (doms || []).flatMap(domaine => domaines.filter(d => d.text === domaine).map(d => d.code));
    return themes.filter(t => {
        const index = codes.findIndex(code => t.code.startsWith(code));
        return index >= 0;
    }).map(t => capitalizeFirstLetter(t.text)).sort();
}
